import { all } from "redux-saga/effects";

import adminSagas from "./admin";
import agenciesSagas from "./agencies";
import allUserInfoSagas from "./all-user-info";
import dispatchEventFeedSagas from "./dispatch-event-feed";
import eventManagementSagas from "./event-management";
import geoJsonSagas from "./geo-json";
import mapSagas from "./map";
import userInfoSagas from "./user-info";
import vccIncidentSagas from "./vcc-incident";

export default function* rootSaga() {
  yield all([
    ...adminSagas,
    ...agenciesSagas,
    ...allUserInfoSagas,
    ...dispatchEventFeedSagas,
    ...eventManagementSagas,
    ...geoJsonSagas,
    ...mapSagas,
    ...userInfoSagas,
    ...vccIncidentSagas,
  ]);
}
